module.exports = __webpack_public_path__ + "static/media/finka_logo_light.fb355797.png";